import { Injectable } from '@angular/core';

export declare type DLSRouteState = 'develop' | 'design' | null;

@Injectable({
  providedIn: 'root'
})
export class DLSRouteStateService {

  private _state: DLSRouteState;
  public get state(): DLSRouteState { return this._state; }
  public set state(state: DLSRouteState) { this._state = state; }

  constructor() {
    this.state = 'develop';
  }

}
